/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.headerModule')
.controller('HeaderTabsController', ['$rootScope', '$window', HeaderTabsController]);

/**
 * Controller for the header menu tabs
 */
function HeaderTabsController($rootScope, $window) {

  var that = this;

/**
 * Style constant for applying a native scrollbar to just the activity feed section because
 * the themed scrollbar directive was not working after refactor of the header tabs markup.
 * This will help in the transtion away from JavaScript generated scrollbars.
 */
  const nativeScrollStyles = {
    'overflow-y': 'auto',
    'max-height': 'calc(100% - 1rem)',
    padding: '0 0 1rem 0'
  }

  that.nativeScrollStyles = nativeScrollStyles;

  this.devToolsEnabled = process.env.DEVTOOLS_ENABLED;
  this.bootstrapEnabled = process.env.BOOTSTRAP_ENABLED;

  this.setActiveTab = function(tab) {

    if (typeof tab !== 'undefined') {

      $rootScope.$emit('headerTabSelected', tab);
    }

    // Need to do it this way to be able to set the tab without clicking on it.
    this.activeTab = {};
    this.activeTab[tab] = true;
  };
  // Setting the default view to Activity
  this.setActiveTab('ACTIVITY');

  /**
   * Set active tab to GROUPS for menu tour.
   * @param tab name to be set active
   */
  $window.menuTour = function (tab) {
    that.setActiveTab(tab);
  };
}
